import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import ViewAll from "@/pages/holiday/ViewAll";
import RestrictedHoliday from "@/pages/holiday/RestrictedHoliday";
import Holiday from "@/pages/holiday/Holiday";
const ColleagueBirthday = React.lazy(() => import("@/pages/dashboard/ColleagueBirthday"));
// const Attendance = React.lazy(() => import("@/pages/dashboard/Attendance"));
// const Birthday = React.lazy(() => import("@/pages/dashboard/BirthdayCard"));
// const AnniversaryWork = React.lazy(() => import("@/pages/dashboard/Anniversary"));
// const Holidays = React.lazy(() => import("@/pages/dashboard/Holidays"));
const Dashboards = React.lazy(() => import("@/pages/dashboard/Dashboard"));
const WorkAnniversary = React.lazy(() => import("@/pages/dashboard/WorkAnniversary"));

const Index = [
  {
    path: "/colleagueBirthday",
    element: (
      <SuspenseWrapper>
        <ColleagueBirthday />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/workAnniversary",
    element: (
      <SuspenseWrapper>
        <WorkAnniversary />
      </SuspenseWrapper>
    ),
  },
 
  {
    path: "dashboard",
    element: (
      <SuspenseWrapper>
        <Dashboards />
      </SuspenseWrapper>
    ),
  },
  // holiday routes
  {
    path: "empHolidays",
    element: (
      <SuspenseWrapper>
        <ViewAll />
      </SuspenseWrapper>
    ),
  },
  {
    path: "restrictedholidays",
    element: (
      <SuspenseWrapper>
        <RestrictedHoliday />
      </SuspenseWrapper>
    ),
  },
  {
    path: "employeeholidays",
    element: (
      <SuspenseWrapper>
        <Holiday />
      </SuspenseWrapper>
    ),
  },
];

export default Index;
